import { HistoryOrderDetail } from "@services/dtos/marketplace.dto";
import { usePageHeader } from "@hooks/use_page_header";
import { toRp } from "@utils/helper";
import moment from "moment";
import { useState } from "react";
import { useLocation } from "react-router-dom";

const MarketplaceHistoryDetailPage = () => {
  const { state } = useLocation();
  usePageHeader("Detail Pesanan", { bottomNavigation: "hidden" });


  return (
    <div className="tw-px-4 tw-pt-2 tw-pb-20">
      {/* detail */}
      {state.detailPesanan != null && state.detailPesanan.length > 0 && (
        <>
          {state.detailPesanan.map((item: HistoryOrderDetail, idx: number) => (
            <div className="tw-mb-6 card-body" key={idx}>
              {/* <div className="tw-text-accent-primary tw-text-xs">Status</div> */}
              <div className="tw-flex tw-items-center tw-justify-between">
                <div className="tw-text-text-secondary tw-text-xs">
                  ID Pesanan:{" "}
                  <span className="tw-text-text-primary tw-font-semibold">
                    {item.idPesanan}
                  </span>
                </div>
                <div className="tw-text-end">
                  <div
                    className={`tw-inline-flex tw-items-center tw-rounded-md tw-px-2 tw-py-1 tw-text-[10px] tw-font-medium tw-ring-1 tw-ring-inset ${
                      item.statusBarang === "DIBATALKAN"
                        ? "tw-bg-red-50 tw-text-red-700 tw-ring-red-600/10"
                        : item.statusBarang === "DITERIMA SANTRI"
                        ? "tw-bg-green-50 tw-text-green-700 tw-ring-green-600/10"
                        : item.statusBarang === "DITERIMA PETUGAS"
                        ? "tw-bg-magenta-50 tw-text-magenta-700 tw-ring-magenta-600/10"
                        : item.statusBarang === "DIKIRIM"
                        ? "tw-bg-green-50 tw-text-green-700 tw-ring-green-600/10"
                        : item.statusBarang === "DIPROSES"
                        ? "tw-bg-blue-50 tw-text-blue-700 tw-ring-blue-600/10"
                        : "tw-bg-slate-50 tw-text-slate-700 tw-ring-slate-600/10"
                    }`}
                  >
                    {item.statusBarang}
                  </div>
                </div>
              </div>

              <div
                className="tw-py-1 tw-my-2 tw-border-[#630d5f33]"
                style={{
                  borderBottom: "1px solid",
                  borderTop: "1px solid",
                }}
              >
                <div className="tw-text-text-secondary">
                  <div className="tw-line-clamp-1 tw-text-sm tw-text-text-primary">
                    {item.namaBarang ?? "-"}
                  </div>
                  <div className="tw-text-xs">
                    {item.jumlahBarang ?? "-"} x{" "}
                    {item.totalHarga > 0
                      ? toRp((item.totalHarga ?? 0) / item.jumlahBarang)
                      : toRp(0)}
                  </div>
                </div>
              </div>

              {item.statusBarang === "DIBATALKAN" ? (
                <>
                  <div className="tw-text-text-secondary tw-text-xs">
                    Catatan Dibatalkan
                  </div>
                  <div className="tw-mb-4 tw-text-text-primary tw-text-sm">
                    {item.catatanBatal === "" ? "-" : item.catatanBatal}
                  </div>
                </>
              ) : (
                <>
                  <div className="tw-text-text-secondary tw-text-xs">
                    Catatan Order
                  </div>
                  <div
                    className={`${
                      item.statusBarang === "DIBATALKAN" ? "tw-mb-2" : ""
                    } tw-text-text-primary tw-text-sm`}
                  >
                    {item.catatanPembeli === "" ? "-" : item.catatanPembeli}
                  </div>
                </>
              )}
            </div>
          ))}
        </>
      )}
      {/* end of detail */}

      {/* general */}
      <div className="card-body">
        <div className="tw-text-text-secondary tw-text-xs">
          {moment(state.orderAt ?? Date.now()).format(
            "dddd, DD MMMM YYYY | HH:mm"
          )}
        </div>
        <div className="tw-mb-4 tw-text-text-primary tw-text-sm">
          {state.detailPesanan.map(
            (item: HistoryOrderDetail, idx: number) =>
              idx === 0 && (
                <div key={idx}>Pembayaran dari {item.metodePembayaran}</div>
              )
          )}
        </div>
        <div className="tw-flex tw-items-center tw-justify-between tw-mb-2">
          <div className="tw-text-text-secondary tw-text-xs">
            Subtotal Pesanan
          </div>
          <div className="tw-text-text-primary tw-text-sm">
            {toRp(state.totalHargaPesanan)}
          </div>
        </div>

        <div className="tw-flex tw-items-center tw-justify-between tw-mb-2">
          <div className="tw-text-text-secondary tw-text-xs">Biaya Layanan</div>
          <div className="tw-text-text-primary tw-text-sm">
            {toRp(state.fee)}
          </div>
        </div>
        <div className="tw-flex tw-items-center tw-justify-between">
          <div className="tw-text-text-secondary tw-text-xs">Total Harga</div>
          <div className="tw-text-text-primary tw-text-base tw-font-bold">
            {toRp((state.totalHargaPesanan ?? 0) + (state.fee ?? 0))}
          </div>
        </div>
      </div>
      {/* end of general */}
    </div>
  );
};

export default MarketplaceHistoryDetailPage;
